import React from 'react';
import styles from './styles.module.css';

export default ({
  id,
  label,
  placeholder,
  value,
  onChange,
  type = 'text',
  required
}) => (
  <div className={styles.container}>
    <label htmlFor={id}>
      {label}
      {required && <span className={styles.required}>(required)</span>}
    </label>
    <input
      id={id}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/text-box/index.js